export default "__VITE_ASSET__DiiqOfjB__"